import {Injectable} from '@angular/core';
import {FormControl} from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class RcFunctionsService {


    constructor() {
    }

    /**
     * Generate and return a random GUID
     * @returns Random unique GUID
     */
    createGuid() {
        return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);

            return v.toString(16);
        });
    }

    /**
     *
     * @param obj
     * @param prefix
     * @returns array represent a query string
     */
    convertArrayForQueryString(obj, prefix) {
        const arr = [];
        let p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                const k = prefix ? prefix + '[' + p + ']' : p,
                    v = obj[p];
                arr.push((v !== null && typeof v === 'object') ?
                    this.convertArrayForQueryString(v, k) :
                    encodeURIComponent(k) + '=' + encodeURIComponent(v));
            }
        }
        return arr;
    }

    /**
     * @param arr - array of objects
     * @param key - field in object
     * @param asc
     * @returns any[]
     */
    sortArrayByKey(arr: any[], key: string, asc = true) {
        if (asc) {
            arr.sort((a, b) => {
                return ((a[key] > b[key]) ? -1 : ((a[key] < b[key]) ? 1 : 0));
            });
        } else {
            arr.sort((a, b) => {
                return ((a[key] < b[key]) ? -1 : ((a[key] > b[key]) ? 1 : 0));
            });
        }
        return arr;
    }

    /**
     * create array of key value numbers
     * @param max
     * @returns number[]
     */
    createValueKeyArray(max) {
        const array = [];

        for (let i = 1; i <= max; i++) {
            array.push({key: i, value: i});
        }

        return array;
    }

    /**
     * clear array from a certain value
     * @param arr - array of any
     * @param clearVal - value to clear
     * @returns any[]
     */
    clearArray(arr: any[], clearVal: any = null) {
        const tmpArr = [];
        arr.forEach((tmpItem) => {
            if (tmpItem !== clearVal) {
                tmpArr.push(tmpItem);
            }
        });
        return tmpArr;
    }

    /**
     * hash object
     * @param data
     * @returns number
     */
    hash(data) {
        let hash = 0, i, chr, len;

        if (data.length === 0) return hash;
        for (i = 0, len = data.length; i < len; i++) {
            chr = data.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    /**
     * hash object
     * @param name
     * @param url
     * @returns string
     */
    getUrlParamByName(name, url = null) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * check if form control is dirty and not valid and return error message according to the error key and the error messages
     * @param formControl
     * @param errors
     * @returns string
     */
    getErrorMsg(formControl: FormControl, errors: any) {
        if(formControl.dirty && formControl.errors) {
            const keys = Object.keys(formControl.errors);
            for(let i = 0; i < keys.length; i++) {
                if (errors[keys[i]]) {
                    return errors[keys[i]];
                }
            }
        }
        return null;
    }
}
